"use client";

// packages/react/accordion/src/accordion.tsx
import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["type"],
  _excluded2 = ["value", "defaultValue", "onValueChange", "collapsible"],
  _excluded3 = ["value", "defaultValue", "onValueChange"],
  _excluded4 = ["__scopeAccordion", "disabled", "dir", "orientation"],
  _excluded5 = ["__scopeAccordion", "value"],
  _excluded6 = ["__scopeAccordion"],
  _excluded7 = ["__scopeAccordion"],
  _excluded8 = ["__scopeAccordion"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { createContextScope } from "@radix-ui/react-context";
import { createCollection } from "@radix-ui/react-collection";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { composeEventHandlers } from "@radix-ui/primitive";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { Primitive } from "@radix-ui/react-primitive";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { createCollapsibleScope } from "@radix-ui/react-collapsible";
import { useId } from "@radix-ui/react-id";
import { useDirection } from "@radix-ui/react-direction";
import { jsx } from "react/jsx-runtime";
var ACCORDION_NAME = "Accordion";
var ACCORDION_KEYS = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"];
var _createCollection = createCollection(ACCORDION_NAME),
  _createCollection2 = _slicedToArray(_createCollection, 3),
  Collection = _createCollection2[0],
  useCollection = _createCollection2[1],
  createCollectionScope = _createCollection2[2];
var _createContextScope = createContextScope(ACCORDION_NAME, [createCollectionScope, createCollapsibleScope]),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createAccordionContext = _createContextScope2[0],
  createAccordionScope = _createContextScope2[1];
var useCollapsibleScope = createCollapsibleScope();
var Accordion = React.forwardRef(function (props, forwardedRef) {
  var type = props.type,
    accordionProps = _objectWithoutProperties(props, _excluded);
  var singleProps = accordionProps;
  var multipleProps = accordionProps;
  return /* @__PURE__ */jsx(Collection.Provider, {
    scope: props.__scopeAccordion,
    children: type === "multiple" ? /* @__PURE__ */jsx(AccordionImplMultiple, _objectSpread(_objectSpread({}, multipleProps), {}, {
      ref: forwardedRef
    })) : /* @__PURE__ */jsx(AccordionImplSingle, _objectSpread(_objectSpread({}, singleProps), {}, {
      ref: forwardedRef
    }))
  });
});
Accordion.displayName = ACCORDION_NAME;
var _createAccordionConte = createAccordionContext(ACCORDION_NAME),
  _createAccordionConte2 = _slicedToArray(_createAccordionConte, 2),
  AccordionValueProvider = _createAccordionConte2[0],
  useAccordionValueContext = _createAccordionConte2[1];
var _createAccordionConte3 = createAccordionContext(ACCORDION_NAME, {
    collapsible: false
  }),
  _createAccordionConte4 = _slicedToArray(_createAccordionConte3, 2),
  AccordionCollapsibleProvider = _createAccordionConte4[0],
  useAccordionCollapsibleContext = _createAccordionConte4[1];
var AccordionImplSingle = React.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange = props.onValueChange,
    onValueChange = _props$onValueChange === void 0 ? function () {} : _props$onValueChange,
    _props$collapsible = props.collapsible,
    collapsible = _props$collapsible === void 0 ? false : _props$collapsible,
    accordionSingleProps = _objectWithoutProperties(props, _excluded2);
  var _useControllableState = useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    value = _useControllableState2[0],
    setValue = _useControllableState2[1];
  return /* @__PURE__ */jsx(AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value ? [value] : [],
    onItemOpen: setValue,
    onItemClose: React.useCallback(function () {
      return collapsible && setValue("");
    }, [collapsible, setValue]),
    children: /* @__PURE__ */jsx(AccordionCollapsibleProvider, {
      scope: props.__scopeAccordion,
      collapsible: collapsible,
      children: /* @__PURE__ */jsx(AccordionImpl, _objectSpread(_objectSpread({}, accordionSingleProps), {}, {
        ref: forwardedRef
      }))
    })
  });
});
var AccordionImplMultiple = React.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange2 = props.onValueChange,
    onValueChange = _props$onValueChange2 === void 0 ? function () {} : _props$onValueChange2,
    accordionMultipleProps = _objectWithoutProperties(props, _excluded3);
  var _useControllableState3 = useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _useControllableState4 = _slicedToArray(_useControllableState3, 2),
    _useControllableState5 = _useControllableState4[0],
    value = _useControllableState5 === void 0 ? [] : _useControllableState5,
    setValue = _useControllableState4[1];
  var handleItemOpen = React.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return [].concat(_toConsumableArray(prevValue), [itemValue]);
    });
  }, [setValue]);
  var handleItemClose = React.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return prevValue.filter(function (value2) {
        return value2 !== itemValue;
      });
    });
  }, [setValue]);
  return /* @__PURE__ */jsx(AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value,
    onItemOpen: handleItemOpen,
    onItemClose: handleItemClose,
    children: /* @__PURE__ */jsx(AccordionCollapsibleProvider, {
      scope: props.__scopeAccordion,
      collapsible: true,
      children: /* @__PURE__ */jsx(AccordionImpl, _objectSpread(_objectSpread({}, accordionMultipleProps), {}, {
        ref: forwardedRef
      }))
    })
  });
});
var _createAccordionConte5 = createAccordionContext(ACCORDION_NAME),
  _createAccordionConte6 = _slicedToArray(_createAccordionConte5, 2),
  AccordionImplProvider = _createAccordionConte6[0],
  useAccordionContext = _createAccordionConte6[1];
var AccordionImpl = React.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    disabled = props.disabled,
    dir = props.dir,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? "vertical" : _props$orientation,
    accordionProps = _objectWithoutProperties(props, _excluded4);
  var accordionRef = React.useRef(null);
  var composedRefs = useComposedRefs(accordionRef, forwardedRef);
  var getItems = useCollection(__scopeAccordion);
  var direction = useDirection(dir);
  var isDirectionLTR = direction === "ltr";
  var handleKeyDown = composeEventHandlers(props.onKeyDown, function (event) {
    var _triggerCollection$cl;
    if (!ACCORDION_KEYS.includes(event.key)) return;
    var target = event.target;
    var triggerCollection = getItems().filter(function (item) {
      var _item$ref$current;
      return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
    });
    var triggerIndex = triggerCollection.findIndex(function (item) {
      return item.ref.current === target;
    });
    var triggerCount = triggerCollection.length;
    if (triggerIndex === -1) return;
    event.preventDefault();
    var nextIndex = triggerIndex;
    var homeIndex = 0;
    var endIndex = triggerCount - 1;
    var moveNext = function moveNext() {
      nextIndex = triggerIndex + 1;
      if (nextIndex > endIndex) {
        nextIndex = homeIndex;
      }
    };
    var movePrev = function movePrev() {
      nextIndex = triggerIndex - 1;
      if (nextIndex < homeIndex) {
        nextIndex = endIndex;
      }
    };
    switch (event.key) {
      case "Home":
        nextIndex = homeIndex;
        break;
      case "End":
        nextIndex = endIndex;
        break;
      case "ArrowRight":
        if (orientation === "horizontal") {
          if (isDirectionLTR) {
            moveNext();
          } else {
            movePrev();
          }
        }
        break;
      case "ArrowDown":
        if (orientation === "vertical") {
          moveNext();
        }
        break;
      case "ArrowLeft":
        if (orientation === "horizontal") {
          if (isDirectionLTR) {
            movePrev();
          } else {
            moveNext();
          }
        }
        break;
      case "ArrowUp":
        if (orientation === "vertical") {
          movePrev();
        }
        break;
    }
    var clampedIndex = nextIndex % triggerCount;
    (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
  });
  return /* @__PURE__ */jsx(AccordionImplProvider, {
    scope: __scopeAccordion,
    disabled: disabled,
    direction: dir,
    orientation: orientation,
    children: /* @__PURE__ */jsx(Collection.Slot, {
      scope: __scopeAccordion,
      children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({}, accordionProps), {}, {
        "data-orientation": orientation,
        ref: composedRefs,
        onKeyDown: disabled ? void 0 : handleKeyDown
      }))
    })
  });
});
var ITEM_NAME = "AccordionItem";
var _createAccordionConte7 = createAccordionContext(ITEM_NAME),
  _createAccordionConte8 = _slicedToArray(_createAccordionConte7, 2),
  AccordionItemProvider = _createAccordionConte8[0],
  useAccordionItemContext = _createAccordionConte8[1];
var AccordionItem = React.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    value = props.value,
    accordionItemProps = _objectWithoutProperties(props, _excluded5);
  var accordionContext = useAccordionContext(ITEM_NAME, __scopeAccordion);
  var valueContext = useAccordionValueContext(ITEM_NAME, __scopeAccordion);
  var collapsibleScope = useCollapsibleScope(__scopeAccordion);
  var triggerId = useId();
  var open = value && valueContext.value.includes(value) || false;
  var disabled = accordionContext.disabled || props.disabled;
  return /* @__PURE__ */jsx(AccordionItemProvider, {
    scope: __scopeAccordion,
    open: open,
    disabled: disabled,
    triggerId: triggerId,
    children: /* @__PURE__ */jsx(CollapsiblePrimitive.Root, _objectSpread(_objectSpread(_objectSpread({
      "data-orientation": accordionContext.orientation,
      "data-state": getState(open)
    }, collapsibleScope), accordionItemProps), {}, {
      ref: forwardedRef,
      disabled: disabled,
      open: open,
      onOpenChange: function onOpenChange(open2) {
        if (open2) {
          valueContext.onItemOpen(value);
        } else {
          valueContext.onItemClose(value);
        }
      }
    }))
  });
});
AccordionItem.displayName = ITEM_NAME;
var HEADER_NAME = "AccordionHeader";
var AccordionHeader = React.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    headerProps = _objectWithoutProperties(props, _excluded6);
  var accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
  var itemContext = useAccordionItemContext(HEADER_NAME, __scopeAccordion);
  return /* @__PURE__ */jsx(Primitive.h3, _objectSpread(_objectSpread({
    "data-orientation": accordionContext.orientation,
    "data-state": getState(itemContext.open),
    "data-disabled": itemContext.disabled ? "" : void 0
  }, headerProps), {}, {
    ref: forwardedRef
  }));
});
AccordionHeader.displayName = HEADER_NAME;
var TRIGGER_NAME = "AccordionTrigger";
var AccordionTrigger = React.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    triggerProps = _objectWithoutProperties(props, _excluded7);
  var accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
  var itemContext = useAccordionItemContext(TRIGGER_NAME, __scopeAccordion);
  var collapsibleContext = useAccordionCollapsibleContext(TRIGGER_NAME, __scopeAccordion);
  var collapsibleScope = useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */jsx(Collection.ItemSlot, {
    scope: __scopeAccordion,
    children: /* @__PURE__ */jsx(CollapsiblePrimitive.Trigger, _objectSpread(_objectSpread(_objectSpread({
      "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
      "data-orientation": accordionContext.orientation,
      id: itemContext.triggerId
    }, collapsibleScope), triggerProps), {}, {
      ref: forwardedRef
    }))
  });
});
AccordionTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "AccordionContent";
var AccordionContent = React.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    contentProps = _objectWithoutProperties(props, _excluded8);
  var accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
  var itemContext = useAccordionItemContext(CONTENT_NAME, __scopeAccordion);
  var collapsibleScope = useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */jsx(CollapsiblePrimitive.Content, _objectSpread(_objectSpread(_objectSpread({
    role: "region",
    "aria-labelledby": itemContext.triggerId,
    "data-orientation": accordionContext.orientation
  }, collapsibleScope), contentProps), {}, {
    ref: forwardedRef,
    style: _objectSpread(_defineProperty(_defineProperty({}, "--radix-accordion-content-height", "var(--radix-collapsible-content-height)"), "--radix-accordion-content-width", "var(--radix-collapsible-content-width)"), props.style)
  }));
});
AccordionContent.displayName = CONTENT_NAME;
function getState(open) {
  return open ? "open" : "closed";
}
var Root2 = Accordion;
var Item = AccordionItem;
var Header = AccordionHeader;
var Trigger2 = AccordionTrigger;
var Content2 = AccordionContent;
export { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTrigger, Content2 as Content, Header, Item, Root2 as Root, Trigger2 as Trigger, createAccordionScope };